import resourceConfig from '../config';

export default {
  resources: {
    [resourceConfig.name]: {
      name: 'Query request |||| Query requests',
      fields: {
      },
    }
  }
}